// The `InfinityNumber` className below is used by a GTM injected script:
// https://www.infinity.co/knowledge-base/article/infinity-javascript

import SmartLink from "common/wrapper/SmartLink";
import { DEFAULT_TEL_NUMBER } from "lib/constants";
import UIIcon, { BACKGROUNDABLE_ICONS, NON_BACKGROUNDABLE_ICONS } from "../UIIcon";

const DynamicPhoneNumber: React.FC<{
    className?: string;
    isLink: boolean;
    prefetch?: boolean;
    defaultNumber?: string;
    prefix?: string;
    iconName?: string;
    showNumber?: boolean;
}> = ({
    className,
    isLink,
    prefetch = false,
    defaultNumber = DEFAULT_TEL_NUMBER,
    prefix,
    iconName,
    showNumber = true,
}) => {
    const cssClassName = `InfinityNumber${!!className && ` ${className}`}`;
    const iconNameParsed = iconName as
        | keyof typeof NON_BACKGROUNDABLE_ICONS
        | keyof typeof BACKGROUNDABLE_ICONS;
    const linkText = showNumber
        ? prefix
            ? `${prefix} ${defaultNumber}`
            : defaultNumber
        : prefix ?? defaultNumber;

    return isLink ? (
        <SmartLink href={`tel:${defaultNumber}`} prefetch={!!prefetch}>
            <a
                className={cssClassName}
                data-ict-discovery-number={`${defaultNumber}`}
                data-ict-silent-replacements="true"
            >
                {iconNameParsed && <UIIcon className={"icon"} icon={iconNameParsed}></UIIcon>}
                <span className="InfinityNumber">{linkText}</span>
            </a>
        </SmartLink>
    ) : (
        <span className={cssClassName}>
            {iconNameParsed && <UIIcon className={"icon"} icon={iconNameParsed}></UIIcon>}
            <span className="InfinityNumber">{defaultNumber}</span>
        </span>
    );
};

export default DynamicPhoneNumber;
